import React from 'react'
import { DataGridActions } from 'components'
import { ExtendedColumn } from 'components/DataGrid/ExtendedColumn'

interface AGDataGridActionsExportsProps {
    testId: string
    data: any[]
    dataGridColumns: ExtendedColumn[]
    disableAllDataGridActions?: boolean
    onCopy: ((colKey: string, row: any) => void) | null

    showCsvExport?: boolean
    onExportCsv?: () => void
    showExcelExport?: boolean
    onExportExcel?: () => void
}

export const AGDataGridActionsExports = ({
    testId,
    data,
    dataGridColumns,
    disableAllDataGridActions = false,
    onCopy = null,
    // showCsvExport = true,
    onExportCsv = () => {},
    // showExcelExport = true,
    onExportExcel = () => {},
}: AGDataGridActionsExportsProps): React.ReactElement => {
    return (
        <>
            <DataGridActions
                columns={dataGridColumns}
                tableData={data}
                testId={testId}
                onCopy={onCopy}
                onExportCsv={onExportCsv}
                onExportXlsx={onExportExcel}
                showExportsMenuUI
                disableExportsBtn={disableAllDataGridActions}
            />
        </>
    )
}
